export function getUrlForPlatform(platform) {
    let url = ""
    if (platform === "BIT") {
        url = process.env.REACT_APP_BITBUCKET_PLATFORM_URL
    } else if (platform === "GIT") {
        url = process.env.REACT_APP_GITHUB_PLATFORM_URL
    } else if (platform === "AZD") {
        url = process.env.REACT_APP_AZURE_PLATFORM_URL
    }

    return url;
}

export function formatDevelopersName(developerName) {
    let firstDeveloperName = "", lasttDeveloperName = "";
    let developersNameSplit = developerName.split(" ");
    if (developersNameSplit[0]) {
        firstDeveloperName = String(developersNameSplit[0]).charAt(0).toUpperCase() + String(developersNameSplit[0]).slice(1);
    }

    if (developersNameSplit[1]) {
        lasttDeveloperName = String(developersNameSplit[1]).charAt(0).toUpperCase() + String(developersNameSplit[1]).slice(1);
    }


    return firstDeveloperName + " " + lasttDeveloperName;
}

export function getPrCommentText(comment, platform) {
    return comment.comment;
}

export function getPrCommentAuthorName(comment, platform) {
    return comment.commentAuthor;
}

export function metricsAgGridFormat(gitMetricData, platform) {
    let allDevelopers = Object.keys(gitMetricData);
    let gitMetricAgFormat = [];
    allDevelopers.forEach(developer => {
        gitMetricAgFormat.push({
            developer: formatDevelopersName(developer),
            totalCommits: gitMetricData[developer]["totalCommits"],
            changesCountAdd: gitMetricData[developer]["changesCount"]["addedLines"],
            changesCountRemoved: gitMetricData[developer]["changesCount"]["removedLines"],
            changesCountTotal: gitMetricData[developer]["changesCount"]["totalChanges"],
            totalMergedPrs: gitMetricData[developer]["totalMergedPrs"],
            totalDeclinedPrs: gitMetricData[developer]["totalDeclinedPrs"],
            totalOpenPrs: gitMetricData[developer]["totalOpenPrs"],
            totalPrComments: gitMetricData[developer]["totalPrComments"],
            prComments: gitMetricData[developer]["prComments"],
            platform: platform
        });
    });

    return gitMetricAgFormat;
}

export function checkDeveloperSelectedOrNot(selected, currentDev, allDeveloper) {
    allDeveloper.forEach(eachDeveloper => {
        if (eachDeveloper.value === currentDev) {
            eachDeveloper.selected = selected;
        }
    });

    return allDeveloper;
}

export function getShortHash(commitHash) {
    return commitHash.slice(0, 8)
}

export function reviewerFormatter(parameters) {
    let allReviewers = parameters.value;
    if (allReviewers.length > 5) {
        allReviewers = allReviewers.slice(4);
    }

    return allReviewers;
}

/**
 * This function accepts a prLink and modifies it to repository redirecting link based on platform.
 * @param prLink api link to get pr details
 * @param platform platform of repository
 * @returns link to repository of provided pr api link
 */
export function prLinkFormatter(prLink, platform) {
    let link = "/";
    if (platform === 'AzureDevOps') {
        let links = prLink.split("/");
        // Extracting parts of the URL
        const host = links[2];//"dev.azure.com"
        const project = links[3] // "tdg-teams-css2"
        const repo = links[4]; // "xSpaces"
        const repoId = links[8];// "f27aa548-cc12-41e8-926f-3097d5f36d72"
        const prId = links[10]; // "307"
        // Constructing the new link
        const newLink = `https://${host}/${project}/${repo}/_git/${repoId}/pullrequest/${prId}`;
        link = newLink;
    } else if (platform === 'GitHub') {
        let links = prLink.split("/");
        // Extracting parts of the URL
        //const host = links[2]  //"github.com"
        const project = links[4]; // "tdgspikeup"
        const repo = links[5]; // "incomeaccess"
        const prId = links[7]; // "2"
        // Constructing the new link
        const newLink = `https://github.com/${project}/${repo}/pull/${prId}`;
        link = newLink;
    } else if (platform === 'BitBucket') {
        let links = prLink.split("/");
        // Extracting parts of the URL 
        const workspace = links[5];  //"qaraweb"
        const project = links[6] // "qaraweb"
        const prId = links[8]; // "25"
        // Constructing the new link
        const newLink = `https://bitbucket.org/${workspace}/${project}/pull-requests/${prId}`;
        link = newLink;
    }
    return link;
}

/**
 * This function generates data array in sequence of export excel columns
 * @param pr A PR object
 * @returns Array of PR fields according to excel export
 */
export function processPrForExport(pr) {
    return [
        pr.prId,
        pr.title,
        pr.sourceBranch,
        pr.destinationBranch,
        pr.prCommentCount,
        pr.reviewers
    ]
}

/**
 * This function generates data array in sequence of export excel columns
 * @param commit A commit object
 * @returns Array of commit fields according to excel export
 */
export function processCommitForExport(commit) {
    return [
        commit.hash,
        commit.addedChanges,
        commit.removedChanges,
        commit.totalChanges,
        commit.message,
        commit.commitDate
    ]
}